import {
  ContentHeader,
  HTMLWrapper,
  SectionContainer,
} from './sectionStyledComponents';

const ParagraphSection = props => {
  return (
    <SectionContainer>
      {props.section.content.map((content, index) => {
        if (!content.header || !content.body) return <></>;

        return (
          <div
            key={`${props.section.title}-${content.header}-
          ${index}`}
          >
            {(!props.isStep || index > 0) && (
              <ContentHeader>{content.header}</ContentHeader>
            )}
            <HTMLWrapper innerHtml={content.body} />
          </div>
        );
      })}
    </SectionContainer>
  );
};

export default ParagraphSection;
